<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Vertical</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="editCompany"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            >
          </vs-col>
        </vs-row>
                <vs-divider class="m-5" />

        <div class="vx-row p-5" v-if="verticalDescription.vertical">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Vertical:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ verticalDescription.vertical }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="verticalDescription.vertical_description">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Vertical Description:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ verticalDescription.vertical_description }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="verticalDescription.is_client_vertical">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Client Vertical:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ verticalDescription.is_client_vertical }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="verticalDescription.status">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Status:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ verticalDescription.status }}
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import _ from "lodash";
import moduleVerticalsManagement from "@/store/vertical-management/moduleVerticalManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
                              abilities : null,

      verticalDescription: [],
      verticalId: null,
    };
  },
  components: {
    "v-select": vSelect,
    moduleVerticalsManagement
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });   
    if (!moduleVerticalsManagement.isRegistered) {
      this.$store.registerModule(
        "verticalsManagement",
        moduleVerticalsManagement
      );
      moduleVerticalsManagement.isRegistered = true;
    }
  },
  mounted() {
        this.verticalId = this.$route.params.verticalId;
        this.fetchVertical()
  },
  methods: {
    fetchVertical() {
      this.$store
        .dispatch("verticalsManagement/fetchVertical", this.verticalId)
        .then(res => {
          console.log(res)
          if(res){
              this.verticalDescription = res.data;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.verticalDescription = true;
            return;
          }
          console.error(err);
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    editCompany() {
      this.$router.push({ path: `edit/${this.verticalId}` });
    },
    convertTime(apiTime) {
      // date = Date.parse(apiTime)
      let date = new Date(apiTime);
      return date.toLocaleString();
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
